<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 50px;padding-top: 20px">
        <el-date-picker v-fixZoom v-model="weekValue" type="week" format="yyyy 第 WW 周" :picker-options="weekOptions" placeholder="选择周" @change="changeWeek"></el-date-picker>
        <el-button type="success" @click="queryDataTable">查询</el-button>
        <el-button type="primary" plain icon="el-icon-plus" @click="addBtn()">新增</el-button>
        <!--        <el-input prefix-icon="el-icon-search" placeholder="输入套餐名称查询" style="width: 250px"></el-input>-->
        <!--        <el-button type="success" @click="queryDataTable">查询</el-button>-->
      </div>
      <div style="max-height: calc(100% - 120px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            label="老人姓名"
            min-width="90"
            align="center">
            <template slot-scope="scope">
              <span>{{getPersonName(scope.row.personid)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="week"
            label="星期"
            min-width="120"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.date}} {{scope.row.week}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="餐厅"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span>{{getRestaurantName(scope.row.restaurantid)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="提供类型"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.type === 1">早餐</span>
              <span v-if="scope.row.type === 2">午餐</span>
              <span v-if="scope.row.type === 3">早餐、午餐</span>
              <span v-if="scope.row.type === 4">晚餐</span>
              <span v-if="scope.row.type === 5">早餐、晚餐</span>
              <span v-if="scope.row.type === 6">午餐、晚餐</span>
              <span v-if="scope.row.type === 7">早餐、午餐、晚餐</span>
            </template>
          </el-table-column>
          <el-table-column
            label="提供菜品、套餐"
            min-width="400"
            align="center">
            <template slot-scope="scope">
              <table border="1" style="border-collapse: collapse;border: #dedfe1;" v-if="scope.row.endArr0.length !== 0">
                <tr v-for="(item0, index0) in scope.row.endArr0" :key="index0">
                  <td><div class="st"><span>{{ item0.name }} / {{ item0.cnt }}份</span></div></td>
                  <td><div class="st" v-if="item0.dish_kcal !== ''"><span>{{ item0.dish_kcal }} kcal</span></div></td>
                  <td>
                    <div class="st" v-if="item0.nutrients !== ''">
                      <table border="1" style="border-collapse: collapse;border: #F5F7FA;margin: auto">
                        <tr><td style="padding: 5px 15px"><span>碳水化合物：{{item0.nutrients.CHO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>碳水化合物：{{item0.nutrients.CHO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>蛋白质：{{item0.nutrients.PRO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>脂肪：{{item0.nutrients.FAT}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>糖类：{{item0.nutrients.SUG}}克</span></td></tr>
                        <tr><td style="padding: 5px"><span>膳食纤维：{{item0.nutrients.DF}}克</span></td></tr>
                      </table>
                    </div>
                  </td>
                  <td>
                    <div class="st" v-if="item0.picture"><img style="height: 80px" :src="baseUrl + 'food/image/' + item0.picture + '?token=' + token"></div>
                  </td>
                </tr>
              </table>
              <table border="1" style="border-collapse: collapse;border: #dedfe1;margin: 5px 0 0" v-if="scope.row.endArr1.length !== 0">
                <tr v-for="(item1, index1) in scope.row.endArr1" :key="index1">
                  <td><div class="st">{{ item1.dishpackagename }} / {{ item1.cnt }}份</div></td>
                  <td><div class="st" v-if="item1.dish_kcal !== ''">{{ item1.dish_kcal }} kcal</div></td>
                  <td>
                    <div class="st" v-if="item1.nutrients !== ''">
                      <table border="1" style="border-collapse: collapse;border: #F5F7FA;margin: auto">
                        <tr><td style="padding: 5px 15px"><span>碳水化合物：{{item1.nutrients.CHO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>蛋白质：{{item1.nutrients.PRO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>脂肪：{{item1.nutrients.FAT}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>糖类：{{item1.nutrients.SUG}}克</span></td></tr>
                        <tr><td style="padding: 5px"><span>膳食纤维：{{item1.nutrients.DF}}克</span></td></tr>
                      </table>
                    </div>
                  </td>
                  <td>
                    <div class="st" v-if="item1.list.length !== 0">
                      <table border="1" style="border-collapse: collapse;border: #dedfe1;margin: 5px auto 0">
                        <tr v-for="(item2, index2) in item1.list" :key="index2">
                          <td><div class="st">{{ item2.name }}</div></td>
                          <td><div v-if="item2.picture" class="st"><img style="height: 100px"  :src="baseUrl + 'food/image/' + item2.picture + '?token=' + token"></div></td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </table>
            </template>
          </el-table-column>
          <el-table-column
            prop="desc"
            label="备注"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delBtn(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-order-menu :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-order-menu>
    </el-dialog>
  </div>
</template>

<script>
import {getToken} from '../../utils/auth'
import {
  deletedishperson,
  querydish,
  querydishpackage,
  queryrestaurant,
  querydishperson,
  queryelderly
} from '../../api/yanglaoyuan'
import addEditOrderMenu from './components/addEditOrderMenu'
import {queryelderlyhasbed} from '../../api/yanglaoyuan/elderly'
export default {
  name: 'orderSet',
  components: {addEditOrderMenu},
  data () {
    return {
      weekValue: null,
      weekOptions: {
        firstDayOfWeek: 1
      },
      sendDate: [],
      token: '',
      entityId: 0,
      restaurants: [], // 餐厅
      dishes: [], // 菜品
      elderly: [], // 老人
      dishpackages: [], // 套餐
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        restaurants: [], // 餐厅
        dishes: [], // 菜品
        elderly: [], // 老人
        dishpackages: [], // 套餐
        isAdd: true,
        row: ''
      },
      // 图片浏览器地址
      baseUrl: ''
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let dateStr = new Date().format('yyyy-MM-dd')
    const date = new Date(dateStr)
    const weekday = date.getDay()
    const start = this.commonType.GetDateStr(-weekday + 1)
    let end = this.commonType.GetDateStr(7 - weekday)
    this.weekValue = dateStr
    this.sendDate = [start, end]
    this.baseUrl = this.commonType.getapi()
    this.token = getToken()
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getRestaurants()
  },
  methods: {
    changeWeek (val) {
      this.currentPage = 1
      if (val) {
        let startTime = new Date(val.getTime()) // 开始时间
        let endTime = new Date(val.getTime() + (24 * 60 * 60 * 1000) * 6) // 结束时间
        let timeArr = [startTime.toISOString().slice(0, 10), endTime.toISOString().slice(0, 10)]
        this.sendDate = timeArr
      } else {
        this.sendDate = []
      }
    },
    // 餐厅
    getRestaurants () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryrestaurant(params, data).then(res => {
        this.restaurants = res.data.restaurants
        this.addEditObj.restaurants = res.data.restaurants
        this.queryDish()
      })
    },
    // 菜品
    queryDish () {
      this.tableData = []
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      querydish(params, data).then(res => {
        this.dishes = res.data.dishes
        this.addEditObj.dishes = res.data.dishes
        this.getElderlyData()
      })
    },
    // 老人
    getElderlyData () {
      let data = {
        e_id: this.$store.state.user.LoginResp.entity_id
      }
      queryelderlyhasbed({}, data).then(res => {
        this.elderly = res.data.elderly
        this.addEditObj.elderly = res.data.elderly
        this.queryDataTable()
      })
    },
    getElderlyData1 () {
      let params = {
        page: 1,
        size: 9999
      }
      let data = {
        e_id: this.$store.state.user.LoginResp.entity_id
      }
      queryelderly(params, data).then(res => {
        this.elderly = res.data.elderly
        this.addEditObj.elderly = res.data.elderly
        this.queryDataTable()
      }).catch(() => {})
    },
    // 套餐
    queryDishPackages () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      querydishpackage(params, data).then(res => {
        this.dishpackages = res.data.dishpackages
        this.addEditObj.dishpackages = res.data.dishpackages
        this.queryDataTable()
      })
    },
    queryDataTable () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      if (this.sendDate.length > 0) {
        params.start = this.sendDate[0]
        params.end = this.sendDate[1]
      }
      let data = {
        eid: this.entityId
      }
      querydishperson(params, data).then(res => {
        let arr = []
        res.data.dishpersons.forEach(item => {
          let endArr0 = []
          let endArr1 = []
          let dishs = item.dishcnts
          let mealids = []
          dishs.forEach(val => {
            let aa = val
            if (val.dishpackageid === 0) {
              aa.nutrients = val.dish_nutrients !== '' ? JSON.parse(val.dish_nutrients) : ''
              endArr0.push(aa)
            } else {
              if (mealids.indexOf(val.dishpackageid) < 0) {
                mealids.push(val.dishpackageid)
              }
            }
          })
          for (let i = 0; i < mealids.length; i++) {
            let obj = {
              dishpackageid: mealids[i],
              dishpackagename: '',
              cnt: '',
              dish_kcal: '',
              nutrients: '',
              list: []
            }
            dishs.forEach(val1 => {
              let bb = val1
              if (obj.dishpackageid === val1.dishpackageid) {
                obj.dishpackagename = val1.dishpackagename
                obj.cnt = val1.cnt
                bb.nutrients = val1.dish_nutrients !== '' ? JSON.parse(val1.dish_nutrients) : ''
                console.log(bb.nutrients)
                if (bb.nutrients !== '') {
                  if (obj.nutrients === '') {
                    obj.nutrients = bb.nutrients
                  } else {
                    obj.nutrients.CHO = parseFloat(obj.nutrients.CHO) + parseFloat(bb.nutrients.CHO)
                    obj.nutrients.PRO = parseFloat(obj.nutrients.PRO) + parseFloat(bb.nutrients.PRO)
                    obj.nutrients.FAT = parseFloat(obj.nutrients.FAT) + parseFloat(bb.nutrients.FAT)
                    obj.nutrients.DF = parseFloat(obj.nutrients.DF) + parseFloat(bb.nutrients.DF)
                    obj.nutrients.SUG = parseFloat(obj.nutrients.SUG) + parseFloat(bb.nutrients.SUG)
                  }
                }
                if (bb.dish_kcal !== '') {
                  if (obj.dish_kcal === '') {
                    obj.dish_kcal = parseFloat(bb.dish_kcal)
                  } else {
                    obj.dish_kcal = obj.dish_kcal + parseFloat(bb.dish_kcal)
                  }
                }
                obj.list.push(bb)
              }
            })
            endArr1.push(obj)
          }
          item.endArr0 = endArr0
          item.endArr1 = endArr1
          arr.push(item)
        })

        this.tableData = arr
        this.totalCells = res.data.cnt
        console.log(this.tableData)
      })
    },
    getRestaurantName (id) {
      let name = id
      for (let i = 0; i < this.restaurants.length; i++) {
        if (id === this.restaurants[i].id) {
          name = this.restaurants[i].name
        }
      }
      return name
    },
    getPersonName (id) {
      let name = id
      for (let i = 0; i < this.elderly.length; i++) {
        if (id === this.elderly[i].id) {
          name = this.elderly[i].name
        }
      }
      return name
    },
    addBtn () {
      this.addEditTitle = '新增订餐'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditTitle = '编辑订餐'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delBtn (row) {
      this.$confirm('此操作将永久删除该订餐【' + row.week + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletedishperson(data).then(res => {
          this.$notify({title: '成功', message: '成功删除', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.queryDataTable()
        })
      })
    },
    updateTable () {
      this.queryDataTable()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>
.st{
  padding: 5px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/orderSet.vue